import { HtmlGraphicObject } from "../html/html-graphic-object.js";
import { NamedObjectContainer, SingleNamedObject } from "../named-object-container";

export class GraphicDiv extends HtmlGraphicObject {
  constructor(settings) {
    super(settings);
    HtmlGraphicObject.setHtmlObject(this.settings, document.createElement("div"));
    this.settings.htmlObject.ref.style.left = `${this.settings.htmlObject.absoluteLocation.x}px`;
    this.settings.htmlObject.ref.style.top = `${this.settings.htmlObject.absoluteLocation.y}px`;
    this.settings.htmlObject.ref.style.width = `${this.settings.htmlObject.sizeInPixels.width}px`;
    this.settings.htmlObject.ref.style.height = `${this.settings.htmlObject.sizeInPixels.height}px`;

    this.childItemsContainer = new NamedObjectContainer("Items");
  }

  setDebugMode(debugSettings) {
    super.setDebugMode(debugSettings);
    if (debugSettings.fillHtmlElements) {
      this.setBackgroundFillColor(this.settings.debug.boxFillColor);
    }
    this.childItemsContainer.forEach(item => item.setDebugMode(debugSettings));
  }

  addItem(name, htmlGraphicChildObject) {
    this.childItemsContainer.add(new SingleNamedObject(name, htmlGraphicChildObject));
  }

  setBackgroundFillColor(color) {
    this.htmlObject.style.backgroundColor = color;
  }

  setBackgroundStrokeColor(color) {
    this.backgroundRectangle.setAttribute("stroke", color);
  }

  createBorders() {
    super.createBorders();
    this.childItemsContainer.forEach(item => {
      item.setParentSize(this.sizeInPixels.width, this.sizeInPixels.height);
      item.createBorders();
    });
  }

  createHtmlBorders() {
    super.createHtmlBorders();
    this.htmlObject.style.left = `${this.htmlObjectBorders.absoluteLocation.x}px`;
    this.htmlObject.style.top = `${this.htmlObjectBorders.absoluteLocation.y}px`;
    this.htmlObject.style.width = `${this.htmlObjectBorders.sizeInPixels.width}px`;
    this.htmlObject.style.height = `${this.htmlObjectBorders.sizeInPixels.height}px`;
  }
}
